import { Directive, Input, SimpleChanges } from '@angular/core';
import { Validator, AbstractControl } from '@angular/forms';
import { NG_VALIDATORS } from '@angular/forms';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[requiredIf]',
   providers:
    [{
        provide: NG_VALIDATORS,
        useExisting: RequiredIfDirective, multi: true
    }]
})
export class RequiredIfDirective implements Validator {
    constructor() { }

    private _onChange: () => void;

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input('requiredIf')
    requiredIf: boolean;

    registerOnValidatorChange(fn: () => void): void { this._onChange = fn; }

    validate(c: AbstractControl) {
        const value = c.value;
        if ((value == null || value === undefined || value === '') && this.requiredIf) {
                return {
                    requiredIf: {condition: this.requiredIf}
                };
        }

        return null;
    }

    OnChanges(changes: SimpleChanges): void {
        if ('requiredIf' in changes) {
            if (this._onChange) { this._onChange(); }
        }
    }
}
